export interface TargetSearch {
  target: string | undefined
}

export function validateTargetSearch(search: Record<string, unknown>): TargetSearch {
  return {
    target: typeof search.target === 'string' ? search.target : undefined,
  }
}
